export const CELL_HEIGHT = 150;
export const IMAGE_HEIGHT = 110;
